import React, { useState,useContext } from 'react';
import { FilenameContext } from './FilenameContext';
const DownloadButton = ({token, fileName}) => {
    const [loading, setLoading] = useState(false);
   
    const buttonStyle = {
        display: 'inline-block',
       
        textDecoration: 'none',

        background: '#668ad8', // ボタン色
        color: '#FFF',
        borderBottom: 'solid 4px #627295',
        borderRadius: '20px',
        animation: 'blink 1s infinite',
        fontSize: 'large',
        fontFamily: 'auto'
    };
    const handleDownload = async () => {
        setLoading(true);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_URL}/api/file_download/${token}`
            );

            console.log("Download response:", response);

            if (!response.ok) {
                if (response.status === 404) {
                    alert("File not found. The URL may be invalid or out of date.");
                } else {
                    alert(`An error has occurred: ${response.statusText}`);
                }

                console.error(
                    "Error fetching download file:",
                    response.statusText
                );
                return;
            }

            // ★ FetchしたZIPファイルをBlobとして取得
            const blob = await response.blob();

            // ★ Blobから一時的なダウンロードURLを作成
            const downloadUrl = window.URL.createObjectURL(blob);

            // ★ ダウンロード用リンクを作成
            const anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "downloads.zip";

            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);

            // ★ 一時URLを解放
            window.URL.revokeObjectURL(downloadUrl);

        } catch (error) {
            console.error("Error downloading file:", error);
            alert("An error has occurred");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <button
                style={{
                    ...buttonStyle
                }}
                
                onClick={handleDownload} disabled={loading}>
                {loading ? 'Generating URL...' : 'Download'}
            </button>
        </div>
    );
};

export default DownloadButton;
